import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { type IMenuItemProps, Menu, PageLayout } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { DiscoverRoutes } from 'pages/discover/route/type'
import { DiscoverContext } from 'pages/discover/context/context'
import { DiscoverStore } from 'pages/discover'
import { DiscoverMenuCollapseButton } from 'pages/discover/layout/DiscoverMenuCollapseButton'

export const DiscoverLayout = observer(() => {
  const entities = useEntitiesContext()
  const discoverStore = useMemo(() => new DiscoverStore(entities), [])

  const items: IMenuItemProps[] = [
    {
      key: 'capture',
      type: 'nav',
      to: DiscoverRoutes.capture,
      label: 'Capture',
      icon: 'magnet',
    },
    {
      key: 'connect',
      type: 'nav',
      to: DiscoverRoutes.connect,
      label: 'Connect',
      icon: 'messageCircleChecked',
    },
    {
      key: 'convert',
      type: 'nav',
      to: DiscoverRoutes.convert,
      label: 'Convert',
      icon: 'target',
    },
    {
      key: 'care',
      type: 'nav',
      to: DiscoverRoutes.care,
      label: 'Care',
      icon: 'messageSmile',
    },
  ]

  const rightContent = (
    <>
      <DiscoverMenuCollapseButton />
      <Outlet />
    </>
  )

  return (
    <DiscoverContext.Provider value={discoverStore}>
      <PageLayout
        store={discoverStore.pageLayoutStore}
        leftContent={<Menu title='Discover' menuItems={items} />}
        rightContent={rightContent}
      />
    </DiscoverContext.Provider>
  )
})
